<div class="animations-carousel-panel__card" #itemEl>
  <div
    class="animations-carousel-panel__card--icon"
    [class.animations-carousel-panel__card--icon--active]="item.state === animationStates.active"
  >
    <img
      *ngIf="item.icon?.value"
      class="mobile-dropdown__icon"
      [class.mobile-dropdown__icon--active]="item.state === animationStates.active"
      [src]="item.icon.value.src"
      [ngStyle]="{aspectRatio: item.icon?.value?.width / item.icon?.value?.height}"
    />
  </div>
  <div>
    <p
      class="animations-carousel-panel__card--header"
      [class.animations-carousel-panel__card--header--active]="item.state === animationStates.active"
    >
      {{ item.header.value }}
    </p>
    <div
      class="animations-carousel-panel__card--description"
      [innerHTML]="item.description.value"
      #itemDesc
    ></div>
  </div>
</div>
